import { Routes } from '@angular/router';
import { OperationsListComponent } from './pages/operations-list/operations-list.component';
import { OperationsDetailComponent } from './pages/operations-detail/operations-detail.component';
import { RoleGuard } from '../core/guards/auth.guard';
import { Permission } from '../core/models/role-permissions.models';

export default [
	{
		path: ':id',
		runGuardsAndResolvers: 'paramsOrQueryParamsChange',
		loadComponent: () => OperationsListComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.OPERATION_VIEW],
			comeback: 'panel',
		},
	},
	{
		path: 'detail/:id',
		loadComponent: () => OperationsDetailComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.OPERATION_VIEW],
			comeback: 'operations',
		},
	},
] as Routes;
